export default "__VITE_ASSET__C_gDq6_p__"